import React from 'react';
import clsx from 'clsx';
import { useFocused, useSelected } from 'slate-react';

/* eslint-disable-next-line no-unused-vars */
export const MergeFieldElement = ({ children, element, renderLabel, attributes, editor, className }) => {
  const { value, error } = element;
  const focused = useFocused();
  const selected = useSelected();
  const _className = clsx(className, error && 'error', focused && 'focused', selected && 'selected');
  return (
    <span
      contentEditable={false}
      className={_className}
      {...attributes}
    >
      {renderLabel ? renderLabel(element) : value}
      {children}
    </span>
  );
};
